import Vue from 'vue';
import UserService from '@/services/user';

import { FETCH_ALL, SEARCH, REMOVE, SAVE } from '../actions.types';
import {
  SET_ERROR,
  SET_ITEM,
  SET_ITEMS,
  SET_FILTERS,
  REMOVE_ITEM
} from '../mutations.types';

export default {
  namespaced: true,
  state: {
    error: null,
    items: [],
    pagination: {},
    filters: {
      page: 1,
      sort: 'name',
      reverse: true
    }
  },
  actions: {
    async [FETCH_ALL]({ commit, state }) {
      try {
        const response = await UserService.query(state.filters);
        commit(SET_ITEMS, response.data);
      } catch (error) {
        commit(SET_ERROR, error.data);
      }
    },
    async [REMOVE]({ commit }, user) {
      try {
        await UserService.delete(user.id);
        commit(REMOVE_ITEM, user);
      } catch (error) {
        commit(SET_ERROR, error.data);
      }
    },
    async [SAVE]({ commit }, user) {
      try {
        await UserService.save(user.id, user);
        commit(SET_ITEM, user);
      } catch (error) {
        commit(SET_ERROR, error.data);
      }
    },
    async [SEARCH]({ commit }, keyword) {
      try {
        const response = await UserService.search(keyword);
        commit(SET_ITEMS, response.data);
      } catch (error) {
        commit(SET_ERROR, error.data);
      }
    }
  },
  mutations: {
    [SET_ERROR](state, error) {
      state.error = error;
    },
    [SET_ITEM](state, user) {
      state.error = null;
      const index = state.items.findIndex(item => item.id === user.id);
      Vue.set(state.items, index, user);
    },
    [SET_ITEMS](state, response) {
      state.error = null;
      state.items = response.data;
      Vue.set(state, 'pagination', response.meta);
    },
    [SET_FILTERS](state, filters) {
      if (!filters.value) {
        Vue.set(state.filters, 'page', 1);
        Vue.delete(state.filters, filters.key);
      } else {
        Vue.set(state.filters, filters.key, filters.value);
      }
    },
    [REMOVE_ITEM](state, user) {
      state.error = null;
      const index = state.items.findIndex(item => item.id == user.id);
      state.items.splice(index, 1);
    }
  }
};
